export default __webpack_public_path__ + "static/media/verified-email.52c4324a.svg";